import styled from "styled-components";
import { Theme } from "../../../styles/theme";


export const ImgStyled = styled.img`
  width: 50%;
  height: 100%;
`

export const InputImg = styled.input`
  color: ${Theme.colors.cor_cinza};
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  margin-left: 10px;
  cursor: pointer;
`

export const BoxImg = styled.div`
  display: block;
  width: 100%;
`
